var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96496 20L20.9937 20V18L2.96496 18V20ZM8.96483 13L20.9932 13V11L8.96483 11L8.96483 13ZM6.96484 14C6.96484 14.412 6.49446 14.6472 6.16484 14.4L3.49818 12.4C3.23151 12.2 3.23151 11.8 3.49818 11.6L6.16484 9.6C6.49446 9.35279 6.96484 9.58798 6.96484 10L6.96484 14ZM2.96503 6L21.0117 6L21.0117 4L2.96503 4L2.96503 6Z",
    fill: "#01142A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3d72314109801e792afe1ede9a6261b3.svg";
export { ForwardRef as ReactComponent };